export const SIZE = 18;
export const RADIUS = SIZE / 4;
export const STROKE_WIDTH = SIZE / 2;
export const CENTER = SIZE / 2;
export const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
